var map = {
	"./A1.png": 5933,
	"./A2.png": 753,
	"./A3.png": 4341,
	"./A4.png": 3291,
	"./A5.png": 3264,
	"./A6.png": 1528,
	"./A7.png": 1840,
	"./Itstars.png": 1337,
	"./bg-news.jpg": 7316,
	"./cont.png": 9114,
	"./cont.svg": 3855,
	"./footer.png": 2129,
	"./ftz.svg": 7906,
	"./ftz_en.svg": 9190,
	"./lang-en.png": 8435,
	"./lang-ru.png": 3719,
	"./logo.png": 6338,
	"./mercury.png": 3780,
	"./news.png": 4630,
	"./news/1.png": 7241,
	"./news/nes-15-6.png": 5981,
	"./news/news-1.1.1.png": 2885,
	"./news/news-1.1.png": 879,
	"./news/news-1.2.png": 3687,
	"./news/news-10-1.png": 9046,
	"./news/news-10-2.png": 2754,
	"./news/news-10-3.png": 6147,
	"./news/news-10-4.png": 5794,
	"./news/news-10.png": 7351,
	"./news/news-11-1.png": 3381,
	"./news/news-11-2.png": 2816,
	"./news/news-11-3.png": 7304,
	"./news/news-11-4.png": 9728,
	"./news/news-11-5.png": 6093,
	"./news/news-11.png": 6371,
	"./news/news-12-1.png": 6977,
	"./news/news-12-2.png": 8472,
	"./news/news-12.png": 4971,
	"./news/news-13.png": 602,
	"./news/news-14-1.jpg": 3917,
	"./news/news-14.png": 9814,
	"./news/news-15-1.png": 4245,
	"./news/news-15-2.png": 4459,
	"./news/news-15-3.png": 1665,
	"./news/news-15-4.png": 3608,
	"./news/news-15-5.png": 8586,
	"./news/news-15-6.png": 7725,
	"./news/news-16-1.png": 8829,
	"./news/news-16-2.png": 4555,
	"./news/news-16-3.png": 3092,
	"./news/news-16.png": 813,
	"./news/news-17-1.png": 5002,
	"./news/news-17.png": 9167,
	"./news/news-18-1.png": 7231,
	"./news/news-18-2.png": 1142,
	"./news/news-18.png": 5066,
	"./news/news-19-1.jpg": 1957,
	"./news/news-19-2.png": 7587,
	"./news/news-19.png": 7900,
	"./news/news-2.png": 2100,
	"./news/news-20.jpg": 9608,
	"./news/news-21-1.png": 3692,
	"./news/news-21-2.png": 4098,
	"./news/news-21.png": 3284,
	"./news/news-22.png": 7100,
	"./news/news-23-1.png": 2508,
	"./news/news-23.png": 1438,
	"./news/news-24-1.png": 5825,
	"./news/news-24.png": 6518,
	"./news/news-25-1.png": 1801,
	"./news/news-25-2.png": 7353,
	"./news/news-25-3.png": 5504,
	"./news/news-25-4.png": 161,
	"./news/news-25.png": 7524,
	"./news/news-26-1.png": 157,
	"./news/news-26-2.png": 5332,
	"./news/news-26-3.png": 3951,
	"./news/news-26.png": 618,
	"./news/news-27-1.png": 8864,
	"./news/news-27-2.png": 3435,
	"./news/news-27-3.png": 5238,
	"./news/news-27-4.png": 223,
	"./news/news-27.png": 5679,
	"./news/news-28-1.jpg": 2188,
	"./news/news-28-2.png": 7016,
	"./news/news-28-3.png": 9501,
	"./news/news-28.png": 7216,
	"./news/news-3.1.png": 7126,
	"./news/news-3.png": 2543,
	"./news/news-4.2.png": 3517,
	"./news/news-4.3.png": 7710,
	"./news/news-4.png": 1173,
	"./news/news-5.1.png": 9836,
	"./news/news-5.png": 9675,
	"./news/news-6.png": 3806,
	"./news/news-7.png": 2364,
	"./news/news-8.gif": 6529,
	"./news/news-8.png": 3485,
	"./news/news-9-1.png": 2746,
	"./news/news-9-2.png": 4298,
	"./news/news-9-3.png": 2066,
	"./news/news-9.png": 9209,
	"./news/news_15_background.png": 293,
	"./partner.png": 4090,
	"./prize.png": 196,
	"./reserv.png": 222,
	"./test.png": 2592,
	"./test/test-img-2_Out.png": 2120,
	"./test/test-img-3_Out.png": 1523,
	"./test/test-img-4_Out.png": 7438,
	"./test/test-img-5_Out.png": 268,
	"./top-bg.jpg": 9428,
	"./Ресурс 5.svg": 3531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;